import React from 'react';

interface IconProps {
  className?: string;
  size?: number;
}

/* ─── Trust Bar Icons ─────────────────────────────────── */

export const GlobeMulticulturalIcon: React.FC<IconProps> = ({ className, size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none" className={className}>
    <circle cx="24" cy="24" r="20" fill="#E8F5E9" />
    <circle cx="24" cy="24" r="16" fill="#4CAF50" />
    <path d="M10 24c0-2 3-4 6-3s4 5 2 7-5 1-6-1-2-2-2-3z" fill="#2E7D32" />
    <path d="M22 10c2-1 5 0 6 2s0 5-2 6-4 0-5-2 0-5 1-6z" fill="#2E7D32" />
    <path d="M32 18c2 0 4 2 4 5s-2 5-4 5-3-1-3-3 1-7 3-7z" fill="#2E7D32" />
    <path d="M18 30c1-1 4-1 6 1s2 5 0 6-5 0-6-2 0-4 0-5z" fill="#2E7D32" />
    <path d="M30 32c2 0 3 1 3 3s-2 3-3 3-3-1-3-3 1-3 3-3z" fill="#2E7D32" />
    <ellipse cx="24" cy="24" rx="16" ry="16" stroke="#388E3C" strokeWidth="1.5" fill="none" />
    <path d="M24 8v32M8 24h32" stroke="#388E3C" strokeWidth="0.8" opacity="0.4" />
    <ellipse cx="24" cy="24" rx="8" ry="16" stroke="#388E3C" strokeWidth="0.8" fill="none" opacity="0.4" />
  </svg>
);

export const CanadaFlagIcon: React.FC<IconProps> = ({ className, size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none" className={className}>
    <rect x="4" y="10" width="40" height="28" rx="3" fill="white" stroke="#E0E0E0" strokeWidth="0.5" />
    <rect x="4" y="10" width="10" height="28" fill="#FF0000" rx="3" />
    <rect x="34" y="10" width="10" height="28" fill="#FF0000" rx="3" />
    <path d="M24 15l1.5 3.5 1-0.5-0.5 2 3-1.5 0.5 2h2l-2.5 2.5 1 2-2.5-1-1 3h-1.5l-1.5-3-1.5 3H21l-1-3-2.5 1 1-2L16 20.5h2l0.5-2 3 1.5-0.5-2 1 0.5L24 15z" fill="#FF0000" />
    <rect x="23" y="27" width="2" height="4" fill="#FF0000" />
  </svg>
);

export const WholesalePricingIcon: React.FC<IconProps> = ({ className, size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none" className={className}>
    <rect x="6" y="8" width="36" height="32" rx="4" fill="#FFF3E0" stroke="#E5A100" strokeWidth="1.5" />
    <rect x="10" y="12" width="28" height="6" rx="2" fill="#E5A100" />
    <circle cx="24" cy="30" r="7" fill="#FFF3E0" stroke="#E5A100" strokeWidth="1.5" />
    <text x="24" y="34" textAnchor="middle" fill="#E5A100" fontSize="11" fontWeight="bold" fontFamily="system-ui">$</text>
    <rect x="13" y="22" width="8" height="2" rx="1" fill="#E5A100" opacity="0.4" />
    <rect x="27" y="22" width="8" height="2" rx="1" fill="#E5A100" opacity="0.4" />
  </svg>
);

export const InteracIcon: React.FC<IconProps> = ({ className, size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none" className={className}>
    <rect x="4" y="12" width="40" height="24" rx="4" fill="#E8F5E9" stroke="#2E8B57" strokeWidth="1.5" />
    <rect x="4" y="16" width="40" height="5" fill="#2E8B57" opacity="0.15" />
    <circle cx="34" cy="30" r="4" fill="#E5A100" opacity="0.8" />
    <circle cx="29" cy="30" r="4" fill="#C43E2A" opacity="0.8" />
    <rect x="10" y="28" width="12" height="2" rx="1" fill="#2E8B57" opacity="0.5" />
    <rect x="10" y="32" width="8" height="2" rx="1" fill="#2E8B57" opacity="0.3" />
  </svg>
);

/* ─── Value Prop Icons ────────────────────────────────── */

export const StorefrontIcon: React.FC<IconProps> = ({ className, size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none" className={className}>
    <rect x="8" y="20" width="32" height="22" rx="2" fill="#FFF3E0" stroke="#8B6F47" strokeWidth="1.5" />
    <path d="M6 20L12 8h24l6 12" fill="#C43E2A" stroke="#C43E2A" strokeWidth="1.5" strokeLinejoin="round" />
    <path d="M6 20c0-2 3-4 6-4s6 2 6 4-3 4-6 4-6-2-6-4z" fill="#E5574F" />
    <path d="M18 20c0-2 3-4 6-4s6 2 6 4-3 4-6 4-6-2-6-4z" fill="#E5574F" />
    <path d="M30 20c0-2 3-4 6-4s6 2 6 4-3 4-6 4-6-2-6-4z" fill="#E5574F" />
    <rect x="19" y="30" width="10" height="12" rx="1" fill="#8B6F47" />
    <rect x="21" y="32" width="6" height="4" rx="0.5" fill="#FFF3E0" />
    <circle cx="27" cy="37" r="1" fill="#E5A100" />
    <rect x="10" y="26" width="6" height="6" rx="1" fill="#2E8B57" opacity="0.2" stroke="#2E8B57" strokeWidth="0.8" />
    <rect x="32" y="26" width="6" height="6" rx="1" fill="#2E8B57" opacity="0.2" stroke="#2E8B57" strokeWidth="0.8" />
  </svg>
);

export const PriceTagIcon: React.FC<IconProps> = ({ className, size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none" className={className}>
    <path d="M8 6h16l18 18-16 16L8 22V6z" fill="#FFF3E0" stroke="#E5A100" strokeWidth="1.5" strokeLinejoin="round" />
    <circle cx="18" cy="16" r="3" fill="#E5A100" />
    <line x1="20" y1="26" x2="32" y2="26" stroke="#E5A100" strokeWidth="2" strokeLinecap="round" />
    <line x1="22" y1="30" x2="30" y2="30" stroke="#E5A100" strokeWidth="1.5" strokeLinecap="round" opacity="0.5" />
    <line x1="24" y1="34" x2="28" y2="34" stroke="#E5A100" strokeWidth="1" strokeLinecap="round" opacity="0.3" />
  </svg>
);

export const DeliveryTruckIcon: React.FC<IconProps> = ({ className, size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none" className={className}>
    <rect x="2" y="14" width="28" height="18" rx="3" fill="#E8F5E9" stroke="#2E8B57" strokeWidth="1.5" />
    <path d="M30 20h8l6 8v4a3 3 0 01-3 3h-11V20z" fill="#2E8B57" stroke="#2E8B57" strokeWidth="1.5" strokeLinejoin="round" />
    <rect x="32" y="22" width="6" height="5" rx="1" fill="#A5D6A7" />
    <circle cx="12" cy="35" r="4" fill="white" stroke="#2E8B57" strokeWidth="2" />
    <circle cx="12" cy="35" r="1.5" fill="#2E8B57" />
    <circle cx="37" cy="35" r="4" fill="white" stroke="#2E8B57" strokeWidth="2" />
    <circle cx="37" cy="35" r="1.5" fill="#2E8B57" />
    <path d="M7 18h12v2H7z" fill="#2E8B57" opacity="0.2" rx="1" />
    <path d="M7 22h8v2H7z" fill="#2E8B57" opacity="0.15" rx="1" />
  </svg>
);

export const HandshakeIcon: React.FC<IconProps> = ({ className, size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none" className={className}>
    <path d="M6 20L16 14l8 4 8-4 10 6v8L32 34l-8-4-8 4L6 28V20z" fill="#FFF3E0" stroke="#8B6F47" strokeWidth="1.5" strokeLinejoin="round" />
    <path d="M16 14l8 8 8-8" stroke="#C43E2A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M12 22l6 4 6-2 6 2 6-4" stroke="#8B6F47" strokeWidth="1.2" strokeLinecap="round" opacity="0.5" />
    <circle cx="10" cy="20" r="3" fill="#C43E2A" opacity="0.15" />
    <circle cx="38" cy="20" r="3" fill="#2E8B57" opacity="0.15" />
    <path d="M22 26l2 2 2-2" stroke="#E5A100" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const ClipboardOrderIcon: React.FC<IconProps> = ({ className, size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none" className={className}>
    <rect x="10" y="6" width="28" height="36" rx="4" fill="#F3E5F5" stroke="#7B1FA2" strokeWidth="1.5" />
    <rect x="18" y="4" width="12" height="6" rx="2" fill="#7B1FA2" />
    <circle cx="18" cy="18" r="2" fill="#7B1FA2" opacity="0.3" />
    <rect x="23" y="17" width="10" height="2" rx="1" fill="#7B1FA2" opacity="0.4" />
    <circle cx="18" cy="25" r="2" fill="#7B1FA2" opacity="0.3" />
    <rect x="23" y="24" width="10" height="2" rx="1" fill="#7B1FA2" opacity="0.4" />
    <circle cx="18" cy="32" r="2" fill="#4CAF50" />
    <path d="M16.5 32l1 1 2.5-2.5" stroke="white" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
    <rect x="23" y="31" width="10" height="2" rx="1" fill="#7B1FA2" opacity="0.4" />
  </svg>
);

export const MulticulturalGlobeIcon: React.FC<IconProps> = ({ className, size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none" className={className}>
    <circle cx="24" cy="24" r="18" fill="#E3F2FD" stroke="#1565C0" strokeWidth="1.5" />
    <path d="M24 6c4 4 6 10 6 18s-2 14-6 18c-4-4-6-10-6-18s2-14 6-18z" fill="#1565C0" opacity="0.15" stroke="#1565C0" strokeWidth="0.8" />
    <path d="M6 24h36M8 16h32M8 32h32" stroke="#1565C0" strokeWidth="0.8" opacity="0.3" />
    <circle cx="14" cy="16" r="3" fill="#C43E2A" opacity="0.6" />
    <circle cx="32" cy="18" r="2.5" fill="#E5A100" opacity="0.6" />
    <circle cx="20" cy="32" r="2.5" fill="#2E8B57" opacity="0.6" />
    <circle cx="34" cy="30" r="2" fill="#7B1FA2" opacity="0.5" />
  </svg>
);

/* ─── Category Card Icons ─────────────────────────────── */

export const MacheteIcon: React.FC<IconProps> = ({ className, size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none" className={className}>
    <path d="M8 40L36 8" stroke="#8B6F47" strokeWidth="3" strokeLinecap="round" />
    <path d="M36 8c2-2 6-1 6 2s-2 4-4 4L10 38" stroke="#9E9E9E" strokeWidth="4" strokeLinecap="round" fill="none" />
    <path d="M36 8l2-1 3 1 1 3-1 2" stroke="#BDBDBD" strokeWidth="1" fill="#E0E0E0" />
    <rect x="6" y="36" width="8" height="6" rx="2" fill="#8B6F47" transform="rotate(-45 10 39)" />
  </svg>
);

export const BandanaIcon: React.FC<IconProps> = ({ className, size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none" className={className}>
    <path d="M8 14l16 20 16-20" fill="#FFC107" stroke="#F57F17" strokeWidth="1.5" strokeLinejoin="round" />
    <path d="M8 14h32" stroke="#F57F17" strokeWidth="2" strokeLinecap="round" />
    <path d="M12 14l-4 6M36 14l4 6" stroke="#F57F17" strokeWidth="1.5" strokeLinecap="round" />
    <rect x="20" y="16" width="8" height="6" rx="1" fill="#388E3C" opacity="0.6" />
    <path d="M22 36l2 4 2-4" stroke="#F57F17" strokeWidth="1.2" strokeLinecap="round" />
  </svg>
);

export const CapIcon: React.FC<IconProps> = ({ className, size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none" className={className}>
    <path d="M8 28c0-10 7-18 16-18s16 8 16 18" fill="#1565C0" />
    <ellipse cx="24" cy="28" rx="20" ry="4" fill="#0D47A1" />
    <path d="M4 28c0 0 4 4 20 4s20-4 20-4" stroke="#0D47A1" strokeWidth="1.5" />
    <rect x="36" y="24" width="10" height="6" rx="1" fill="#0D47A1" transform="rotate(-5 38 27)" />
    <circle cx="24" cy="16" r="3" fill="#E5A100" />
  </svg>
);

export const KeychainIcon: React.FC<IconProps> = ({ className, size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none" className={className}>
    <circle cx="20" cy="16" r="10" fill="#F3E5F5" stroke="#7B1FA2" strokeWidth="1.5" />
    <circle cx="20" cy="16" r="5" fill="none" stroke="#7B1FA2" strokeWidth="1.5" />
    <path d="M28 22l12 12" stroke="#9E9E9E" strokeWidth="2.5" strokeLinecap="round" />
    <path d="M36 30l4 1M38 32l1 4" stroke="#9E9E9E" strokeWidth="2" strokeLinecap="round" />
    <rect x="14" y="12" width="12" height="8" rx="4" fill="#7B1FA2" opacity="0.15" />
  </svg>
);

export const SunglassesIcon: React.FC<IconProps> = ({ className, size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none" className={className}>
    <path d="M4 20h40" stroke="#333" strokeWidth="2" strokeLinecap="round" />
    <ellipse cx="15" cy="24" rx="9" ry="7" fill="#1A1A1A" stroke="#333" strokeWidth="1.5" />
    <ellipse cx="33" cy="24" rx="9" ry="7" fill="#1A1A1A" stroke="#333" strokeWidth="1.5" />
    <path d="M24 22c-1-2-4-2-6-1" stroke="#4FC3F7" strokeWidth="1" opacity="0.5" />
    <path d="M30 22c1-2 4-2 6-1" stroke="#4FC3F7" strokeWidth="1" opacity="0.5" />
    <path d="M24 21a3 3 0 00-3 0M24 21a3 3 0 013 0" stroke="#333" strokeWidth="1.5" />
  </svg>
);

export const EarringsIcon: React.FC<IconProps> = ({ className, size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none" className={className}>
    <circle cx="16" cy="14" r="3" fill="#E91E63" opacity="0.3" stroke="#E91E63" strokeWidth="1" />
    <circle cx="16" cy="28" r="8" fill="none" stroke="#E5A100" strokeWidth="2.5" />
    <circle cx="16" cy="28" r="5" fill="none" stroke="#E5A100" strokeWidth="1.5" opacity="0.5" />
    <circle cx="32" cy="14" r="3" fill="#E91E63" opacity="0.3" stroke="#E91E63" strokeWidth="1" />
    <circle cx="32" cy="28" r="8" fill="none" stroke="#E5A100" strokeWidth="2.5" />
    <circle cx="32" cy="28" r="5" fill="none" stroke="#E5A100" strokeWidth="1.5" opacity="0.5" />
    <line x1="16" y1="17" x2="16" y2="20" stroke="#E5A100" strokeWidth="1.5" />
    <line x1="32" y1="17" x2="32" y2="20" stroke="#E5A100" strokeWidth="1.5" />
  </svg>
);

export const SmudgeSticksIcon: React.FC<IconProps> = ({ className, size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none" className={className}>
    <path d="M20 40V18c0-4 2-8 4-10 2 2 4 6 4 10v22" fill="#8BC34A" stroke="#558B2F" strokeWidth="1.5" />
    <path d="M16 38V22c0-3 1.5-6 3-8" stroke="#689F38" strokeWidth="2" strokeLinecap="round" fill="#A5D6A7" />
    <path d="M28 38V22c0-3-1.5-6-3-8" stroke="#689F38" strokeWidth="2" strokeLinecap="round" fill="#A5D6A7" />
    <ellipse cx="24" cy="10" rx="2" ry="3" fill="#E0E0E0" opacity="0.6" />
    <path d="M23 6c-1-2 0-4 1-4s2 2 1 4" stroke="#BDBDBD" strokeWidth="0.8" fill="none" />
    <path d="M25 5c1-2 2-3 2-1s-1 3-2 3" stroke="#BDBDBD" strokeWidth="0.8" fill="none" />
    <rect x="18" y="38" width="12" height="4" rx="1" fill="#795548" />
    <path d="M18 40h12" stroke="#5D4037" strokeWidth="0.8" />
  </svg>
);

export const FlagIcon: React.FC<IconProps> = ({ className, size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none" className={className}>
    <rect x="10" y="6" width="3" height="38" rx="1.5" fill="#795548" />
    <path d="M13 8h24l-5 8 5 8H13V8z" fill="#C43E2A" />
    <path d="M13 8h24l-5 8 5 8H13" stroke="#B71C1C" strokeWidth="1" fill="none" />
    <rect x="16" y="12" width="10" height="2" rx="1" fill="white" opacity="0.4" />
    <rect x="16" y="18" width="7" height="2" rx="1" fill="white" opacity="0.3" />
    <circle cx="11.5" cy="6" r="2.5" fill="#E5A100" />
  </svg>
);

export const CarMirrorIcon: React.FC<IconProps> = ({ className, size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none" className={className}>
    <path d="M24 4v14" stroke="#9E9E9E" strokeWidth="1.5" />
    <rect x="12" y="18" width="24" height="14" rx="3" fill="#E3F2FD" stroke="#1565C0" strokeWidth="1.5" />
    <rect x="15" y="21" width="18" height="8" rx="1.5" fill="#BBDEFB" />
    <path d="M20 34v4l-4 4M28 34v4l4 4" stroke="#C43E2A" strokeWidth="2" strokeLinecap="round" />
    <rect x="16" y="38" width="8" height="6" rx="1" fill="#C43E2A" />
    <rect x="24" y="38" width="8" height="6" rx="1" fill="#2E8B57" />
    <rect x="18" y="40" width="4" height="2" rx="0.5" fill="white" opacity="0.3" />
  </svg>
);

/* ─── Windbreaker Icon (for Shop tab) ─────────────────── */

export const WindbreakerIcon: React.FC<IconProps> = ({ className, size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none" className={className}>
    <path d="M16 12h16l4 8v18H12V20l4-8z" fill="#1565C0" stroke="#0D47A1" strokeWidth="1.5" strokeLinejoin="round" />
    <path d="M24 12v26" stroke="#BBDEFB" strokeWidth="1" />
    <path d="M16 12l-8 10v8l8-2V12z" fill="#1976D2" stroke="#0D47A1" strokeWidth="1" strokeLinejoin="round" />
    <path d="M32 12l8 10v8l-8-2V12z" fill="#1976D2" stroke="#0D47A1" strokeWidth="1" strokeLinejoin="round" />
    <circle cx="24" cy="8" r="4" fill="#FFCCBC" stroke="#E64A19" strokeWidth="1" />
    <path d="M20 16h3v2h-3zM25 16h3v2h-3z" fill="#BBDEFB" opacity="0.5" />
  </svg>
);

export default {
  GlobeMulticulturalIcon,
  CanadaFlagIcon,
  WholesalePricingIcon,
  InteracIcon,
  StorefrontIcon,
  PriceTagIcon,
  DeliveryTruckIcon,
  HandshakeIcon,
  ClipboardOrderIcon,
  MulticulturalGlobeIcon,
  MacheteIcon,
  BandanaIcon,
  CapIcon,
  KeychainIcon,
  SunglassesIcon,
  EarringsIcon,
  SmudgeSticksIcon,
  FlagIcon,
  CarMirrorIcon,
  WindbreakerIcon,
};
